/* hs-eslint ignored failing-rules */
/* eslint-disable hubspot-dev/no-confusing-browser-globals */
/* eslint-disable promise/catch-or-return */
/* eslint-disable prefer-promise-reject-errors */

'use es6';

import quickFetch from 'quick-fetch';
import { fromJS, Map as ImmutableMap } from 'immutable';
import http from 'hub-http/clients/apiClient';
import normalizeReport from 'reporting-reports/normalizeReport';
const BASE_URL = 'dashboard/v2/reports';
export const getReports = (query = {}) => {
  return http.get(BASE_URL, {
    query: Object.assign({}, query, {
      source: 'REPORTING'
    })
  }).then(fromJS);
};
export const getReportsWithEarlyRequester = (query = {}) => {
  const earlyRequest = quickFetch.getRequestStateByName('reports');
  const useDefaultFilters = location.search === '';
  if (earlyRequest && useDefaultFilters) {
    return new Promise((resolve, reject) => {
      earlyRequest.whenFinished(request => {
        resolve(fromJS(request));
        quickFetch.removeEarlyRequest('reports');
      });
      earlyRequest.onError(xhr => {
        if (xhr.status !== 401) {
          getReports(query).then(resolve, reject);
        } else {
          reject();
        }
        quickFetch.removeEarlyRequest('reports');
      });
    });
  } else {
    return getReports(query);
  }
};
export const getReport = id => http.get(`${BASE_URL}/${id}`).then(fromJS);
export const getReportCounts = () => {
  return http.get(`${BASE_URL}/report-counts`, {
    query: {
      widgetCounts: true
    }
  }).then(fromJS);
};
export const getRestorableReports = (query = {}) => {
  return http.get(`${BASE_URL}/inactive-restorable`, {
    query
  }).then(fromJS);
};
export const getUnusedReports = (query = {}) => {
  return http.get(`${BASE_URL}/stale`, {
    query: Object.assign({}, query, {
      source: 'REPORTING'
    })
  }).then(fromJS);
};
export const getFilteredReportCount = query => {
  return http.get(`${BASE_URL}/count`, {
    query: Object.assign({}, query, {
      source: 'REPORTING'
    })
  }).then(fromJS);
};

//NOTE: When ids is empty, the action applies to all reports (filtered by the query string)
export const bulkDeleteReports = (ids = [], query) => {
  return http.post(`${BASE_URL}/bulk-delete`, {
    data: ids,
    query: Object.assign({}, query, {
      source: 'REPORTING'
    })
  });
};
export const updateReport = (reportId, report = ImmutableMap()) => {
  const data = report.toJS();
  return http.put(`${BASE_URL}/${reportId}`, {
    data
  }).then(fromJS).then(normalizeReport);
};
export const createReport = (report = ImmutableMap()) => {
  const data = report.toJS();
  return http.post(`${BASE_URL}`, {
    data
  }).then(fromJS).then(normalizeReport);
};

//NOTE: When objectIds is empty, the action applies to all reports (filtered by the query string)
export const bulkChangeReportOwner = (objectIds = [], ownerId, query) => http.put(`${BASE_URL}/owner`, {
  data: {
    objectIds,
    ownerId
  },
  query: Object.assign({}, query, {
    source: 'REPORTING'
  })
});

//NOTE: When reportIds is empty, the action applies to all reports (filtered by the query string)
export const bulkSetPermission = (reportIds = [], data, query) => {
  return http.put(`${BASE_URL}/permission`, {
    data: Object.assign({
      reportIds
    }, data),
    query: Object.assign({}, query, {
      source: 'REPORTING'
    })
  }).then(fromJS);
};